<template>
  <div class="feed-back-detail flow">
    <div class="header">
      <i class="icon icon-fanhuijiantou" @click="jump(-1)"></i>
      <div class="title">
        {{ $t('asm_feedBackDetail.zlfkxq') }}
      </div>
      <div class="btn-content">
        <el-button type="primary" v-if="funcView.feed_back_manage_apply && `${info.approvalState}`!=='10'" @click="onApproval()">{{ funcView.feed_back_manage_apply }}</el-button>
        <el-button type="primary" v-if="funcView.feed_back_manage_edit_result && `${info.approvalState}`==='10'" @click="onEditDone()">{{ funcView.feed_back_manage_edit_result }}</el-button>
      </div>
    </div>
    <div class="user-info-content">
      <div class="header">
        <div class="param-content">
          <ul class="param-list">
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_feedBackDetail.shen_pi_zhuang_tai') }}</div>
                <div class="val">
                  {{info.flowNodeName  }}
                  {{getDicValue('approveStatus', info.approvalState)}}
                </div>
              </div>
            </li>

            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_feedBackDetail.shen_qing_shi_jian') }}</div>
                <div class="val">
                  {{momentAmPm($momentLocal(info.gmtCreate))  }}
                </div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_feedBackDetail.shen_qing_ren') }}</div>
                <div class="val">{{ info.creator }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_feedBackDetail.shen_qing_zu_zhi') }}</div>
                <div class="val">{{ info.applyOrgName }}</div>
              </div>
            </li>
            <li class="item text-right">
              <div class="param-item">
                <div class="key">{{ $t('asm_feedBackDetail.yi_fan_zong_bu') }}</div>
                <div class="val">{{ getDicValue('isynergy_cloud_bool',info.isReturnHq) }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="bar-content">
        <feedBack-process-bar :state="state"></feedBack-process-bar>
      </div> -->
    </div>
    <div class="content ub">
      <div class="tab-container">
        <custom-tab :list="tabData" v-model="tabIndex"></custom-tab>
        <div class="tab-content">
          <!-- 内容详情 -->
          <feedBack-content v-if="tabIndex === 'feedBack_content'" :feedBackId="info.feedBackId" :info="info"></feedBack-content>
          <!-- 审批结果 -->
          <feedBack-analysis v-if="tabIndex === 'feedBack_analysis'" :feedBackId="info.feedBackId"></feedBack-analysis>
        </div>
      </div>
      <!-- 反馈动态 -->
      <feedBack-dynamic v-if="info.feedBackId" :feedBackId="info.feedBackId"></feedBack-dynamic>
    </div>
    <!-- 编辑审批内容 -->
    <feedBack-editDone-dialog v-if="dialogVisible" @close="dialogVisible = false" :model="dialogModel" @success="getInfo"></feedBack-editDone-dialog>
  </div>
</template>

<script>
/*
feedBackProcessBar状态
approvalState
flowNodeNo 共用

工单信息缺字段

*/
import apis from '@/utils/apis';
import feedBackEditDoneDialog from '@/pages/asm/components/feedBack_editDone_dialog';
import feedBackContent from './children/feedBack_content';
import feedBackAnalysis from './children/feedBack_analysis';
import feedBackDynamic from './children/feedBack_dynamic';


export default {
  name: 'feedBackDetail',
  provide() {
    return {
      getInfo: () => this.info,
    };
  },
  mixins: [],
  components: {
    // feedBackProcessBar,
    feedBackContent,
    feedBackAnalysis,
    feedBackDynamic,
    feedBackEditDoneDialog,
  },
  data() {
    return {
      info: {},
      feedBackId: '',
      tabIndex: '',
      imgList: [],
      // 编辑已完成的结果
      dialogModel: {},
      dialogVisible: false,
    };
  },
  computed: {
    state() {

      return this.info.approvalState;

    },

    tabData() {
      /**

       */
      let ret = [];
      ret = [
        {
          name: this.$t('asm_feedBackDetail.nei_rong_xiang_qing'),
          value: 'feedBack_content',
        },
        {
          name: this.$t('asm_feedBackDetail.shen_pi_jie_guo'),
          value: 'feedBack_analysis',
        }
      ];
      return ret;
    },
    curProductImg() {
      if (this.imgList.length) {
        return this.imgList[0].url;
      }
      return '';
    },
  },
  watch: {
    tabData(val) {
      if (val && val.length) {
        this.initTabIndex();
      }
    },
    // fix: 从案例详情跳转工单详情时，页面不刷新
    $route(val) {
      if (val.meta && val.meta.keep === 'feedBackDetail') {
        this.init();
      }
    },
  },
  methods: {
    // 编辑审批内容
    onEditDone() {
      this.dialogVisible = true;
      this.dialogModel = {
        title: this.$t('asm_feedBackDetail.bian_ji_shen_pi'),
        data: this.info,
        type: 'edit',
      };
    },
    onApproval() {
      this.jump('/examine/approvalDetail', {
        workflowType: 'feed_back',
        bizId: this.info.feedBackId,
        flowNodeNo: this.info.flowNodeNo
      });
    },
    onSuccess() {
      this.getInfo();
      this.Bus.$emit('caseOrderChange');
    },

    getImgList() {
      if (!this.info.productCodeId) {
        return;
      }
      this.$getFileList({ bizId: this.info.productCodeId, bizType: 'dms.product.icon' }).then((list) => {
        this.imgList = list;
      });
    },
    initTabIndex() {
      if (this.tabData.length) {
        this.tabIndex = this.tabData[0].value;
      }
    },

    getInfo() {
      this.initTabIndex();
      this.$getJSON(apis.feedbackInfo, { feedBackId: this.feedBackId }).then((res) => {
        this.info = res.data;
      });
    },
    init() {
      this.feedBackId = this.getJump('feedBackId');
      this.getInfo();
    },
  },
  created() {},
  mounted() {
    this.init();
    this.getFuncView('/workorder/feedBack');
  },
  activated() {},
};
</script>

<style lang="scss" scoped>
.feed-back-detail {
  padding: 0 16px 16px;

  display: flex;
  flex-direction: column;

  > .header {
    padding: 24px 0 16px 0;
    height: 68px;
    overflow: hidden;
    .icon {
      font-size: 16px;
      float: left;
      line-height: 30px;
      font-weight: bold;
    }
    .title {
      float: left;
      margin-left: 18px;
      color: #394668;
      font-size: 18px;
      line-height: 32px;
      &:hover {
        cursor: pointer;
      }
    }

    .btn-content {
      float: right;
    }
  }

  > .user-info-content {
    background: #fff;
    padding-bottom: 16px;

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    > .header {
      overflow: hidden;
      height: 86px;
      padding: 0 24px;
      display: flex;

      .param-item {
        text-align: center;
        > .key {
          font-size: 12px;
          color: #6c757d;
          line-height: 18px;
        }
        > .val {
          color: #495057;
          font-size: 12px;
          font-weight: bold;
          margin-top: 4px;
          line-height: 24px;
        }
      }

      .user-info {
        float: left;
        margin-top: 24px;

        .user-icon {
          $r: 46px;
          width: $r;
          height: $r;
          float: left;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          background-image: url('~@/images/layout/head.png');
        }
        .user-text-info {
          float: left;
          margin-left: 22px;
        }
      }

      .param-content {
        flex: 1;
        width: 0;
        overflow-x: auto;
        margin-right: 27px;
        margin-top: 24px;
        .param-list {
          overflow: hidden;
          float: right;
          > .item {
            float: left;
            margin-left: 50px;
            margin-bottom: 10px;
          }
        }
      }
    }

    > .bar-content {
      padding: 0 24px;
    }

    > .order-desc {
      overflow: hidden;
      padding: 0 32px;
      margin-top: 16px;
      display: flex;
      color: #495057;
      font-size: 12px;
      > .val {
        flex: 1;
        word-break: break-all;
      }
    }
  }

  > .content {
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    margin-top: 16px;
    .tab-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      background: #fff;

      .tab-content {
        flex: 1;
        overflow-y: auto;
      }
    }
  }
}
</style>
